// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3XBvp","productName":"Table_productName__38Pa6"};